import React, { useState } from 'react';
import sideProjects from '../sideProjects';
import Nav from './Nav';
import {Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';

import Zoom from 'react-reveal/Zoom';

class Work extends React.Component {
 




  render(){ 
      let id = this.props.match.params.id
      let work = sideProjects.find(x => x.slug === id);
      let next = sideProjects.findIndex(x => x.slug === id) + 1;
      let nextWork 
      if(sideProjects[next]){
          nextWork = sideProjects[next]
      }else{
          nextWork = sideProjects[0]
      }
      // going to a new project the page needs to scrool up and since the url doesnt "change" it needs to be done manually
      {window.scrollTo(0,0)}
     
          return (
                <React.Fragment>


<Nav/>



                    <div className="mainWrapper">
                    <Fade ssrFade left delay={100}>
                        <h1>{work.name}</h1>
                        
                        <p  className="work-paragraphs">{work.desc}</p>
                       
                            <div>
                            <a target="blank" href={work.link}>{work.link.replace(/(^\w+:|^)\/\//, '')}</a>
                            </div>
    
                        <img className="workHero" src={work.mainImg} ></img>
 

                     <h2>Role</h2>
                     <p  className="work-paragraphs">{work.roleTags}</p>
                     <p  className="work-paragraphs">{work.role}</p>
                 
                        {Object.keys(work.imgs).map((key, e) => 
                        <div>
                        {work.imgs[e].split('.')[1] === "jpg" || work.imgs[e].split('.')[1] === "png" ?  <img  src={work.imgs[e]} alt=""/> : <video width="100%" height="auto" autoplay="true" controls muted> <source src={work.imgs[e]} type={"video/mp4"}></source> </video> }
                        </div>
                               
                            
                        )}
                       
                       
                        </Fade>
                    </div>

                </React.Fragment>
            )
    } }

export default Work;